import { type FC, type MouseEvent, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Icon } from "../../ui";
import NavItem from "./NavItem";
import { navItems } from "./navItems";
import { type AdminSidebarProps } from "./AdminSidebar.types";
import styles from "./AdminSidebar.module.scss";
import Spacing from "../../ui/Spacing";

const AdminSidebar: FC<AdminSidebarProps> = ({ onLogout }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const handleLogout = useCallback(
    (e: MouseEvent<HTMLAnchorElement>): void => {
      e.preventDefault();
      onLogout?.();
    },
    [onLogout],
  );

  return (
    <nav className={styles["admin-sidebar"]}>
      {/* Logo Section */}

      {/* Navigation items */}
      <Spacing
        className={styles["navigation-items"]}
        display="flex"
        direction="column"
        gapY={4}
        gapX={8}
      >
        {navItems.map((item) => (
          <NavItem
            key={item.id}
            item={item}
            isActive={currentPath === item.href}
            // isActive={false}
          />
        ))}
      </Spacing>

      {/* Logout Button */}
      <Spacing className={styles["logout-container"]}>
        <a href="#" className={styles["nav-item"]} onClick={handleLogout}>
          {/*  Default Icon */}
          <Icon name="icon-logout" size={24} />

          <span className={styles.navLabel}>Logout</span>
        </a>
      </Spacing>
    </nav>
  );
};

export default AdminSidebar;
